import { isNumber, isString } from "../utils/schemaUtils";

// One conversation-thread comment. Line-anchored pull request review comments
// are never carried here.
export interface GitHubComment {
  id: string;
  author: string;
  body: string;
  createdAt: string;
  url: string;
}

export const isGitHubComment = (v: unknown): v is GitHubComment => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.author) && isString(r.body) && isString(r.createdAt) && isString(r.url);
};

export interface GitHubCommentsPayload {
  type: "github_comments";
  reference: string;
  page: number;
  comments: GitHubComment[];
  hasMore: boolean;
}

export const parseGitHubCommentsPayload = (v: unknown): GitHubCommentsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_comments") return null;
  if (!isString(r.reference)) return null;
  if (!isNumber(r.page)) return null;
  if (!Array.isArray(r.comments) || !r.comments.every(isGitHubComment)) return null;
  if (typeof r.hasMore !== "boolean") return null;
  return {
    type: "github_comments",
    reference: r.reference,
    page: r.page,
    comments: r.comments,
    hasMore: r.hasMore,
  };
};
